import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useEnabledVendorUsers } from "~/hooks/vendors/useVendorUsers";
import type { DealSearchCondition } from "~/models/Deal";
import type { VendorUser } from "~/models/VendorUser";
import { convertToComboBoxOption } from "~/models/VendorUser";

export function VendorUserCombobox() {
	const { data: vendorUsers } = useEnabledVendorUsers();
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const userId = useWatch({ control, name: "userId" });

	const selectedVendorUser = vendorUsers?.find(({ id }) => id === userId);

	const onVendorUserChange = useCallback(
		(value: ComponentProps<typeof SingleComboBox>["value"]) => {
			setValue("userId", value ? Number(value.value) : undefined);
		},
		[setValue]
	);
	if (vendorUsers === null) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onVendorUserChange}
			options={vendorUsers.map((vendorUser: VendorUser) =>
				convertToComboBoxOption(vendorUser)
			)}
			placeholder="担当者"
			value={
				selectedVendorUser ? convertToComboBoxOption(selectedVendorUser) : null
			}
		/>
	);
}
